<template>
   <div class="view-participant-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="udpateCloseViewParticipantDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-4 col-lg-4 text-align-right padding-right-0Px">
                  <!-- Picture: -->
                </div>
                <div class="col-md-6 col-lg-6 text-align-left">
                  <img :src="userImageUrlValue" class="img-circle user-img-width-height background-color" id="userImg" @error="assignDefaultImage"/>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  First Name:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{firstNameValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Last Name:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{lastNameValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Email:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{emailIdValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Username:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{usernameValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 User Location:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{locationValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  School:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{schoolValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Self Summary:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{selfSummaryValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Gender:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{genderValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Created TS:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{formatAndShowDate(createdTSValue)}}
                </div>
                    <!-- <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                      Disabled:
                    </div>
                    <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                      {{disabledValue}}
                    </div> -->
                 <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                      Best Score:
                    </div>
                    <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                      {{bestScoreValue}}
                 </div>   
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Disable Profile Edit:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{disableProfileEditValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Disable Offline:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{disableOfflineValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Session Timeout:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{sessionTimeOutValue}} {{sessionTimeOutUnitValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Account Type:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{accountTypeValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  User Group:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{userGroupValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px" v-if="showAdminGroupName">
                  Admin Group:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left" v-if="showAdminGroupName">
                  {{adminGroupName}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  iOS Version:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{iOSVersionValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Web Version:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{webVersionValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Logged In with SSO:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{loginWithSSOValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Android Version:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                {{androidVersionValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Group:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{groupNameValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Registered Timezone:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                {{userTimeZoneValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Enable MS Team Notfications:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{enableMSTeamsValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  MS Team Email:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                {{msTeamEmailIdValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Cohort Name:
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                  {{cohortNameValue}}
                </div>
                <div class="font-size-15px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-15px col-md-3 col-lg-3 text-align-left">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseViewParticipantDetailOverlay($event)">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div> 
</template>
<script>
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { groupService } from '@/server-util/group-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import ErrorImage from '../assets/images/usericon2.svg'
import find from 'lodash/find'
export default {
  props: ['userObj'],
  name: 'view-participant-details',
  created () {
    this.setDefaultValues()
    this.getGroups()
  },
  data: function () {
    return {
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      adminGroupName: '',
      showAdminGroupName: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    setDefaultValues: function () {
      if (parseInt(this.userObj.AccountType) === constants.UserAccountType.Group_Admin) {
        for (var i = 0; i < this.$store.state.groupList.length; i++) {
          if (this.$store.state.groupList[i].GroupId === this.userObj.GroupAdminId) {
            this.adminGroupName = this.$store.state.groupList[i].GroupName
            break
          }
        }
        this.showAdminGroupName = true
      } else {
        this.showAdminGroupName = false
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    udpateCloseViewParticipantDetailOverlay: function (event) {
      console.log(JSON.stringify(this.userObj))
      this.$emit('closeViewParticipant', false)
    },
    assignDefaultImage: function (event) {
      document.getElementById('userImg').src = ErrorImage
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.setDefaultValues()
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    firstNameValue: {
      get: function () {
        return this.userObj.FirstName
      }
    },
    lastNameValue: {
      get: function () {
        return this.userObj.LastName
      }
    },
    locationValue: {
      get: function () {
        return this.userObj.Location === null || this.userObj.Location === 'null' ? '' : this.userObj.Location
      }
    },
    emailIdValue: {
      get: function () {
        return this.userObj.EmailId
      }
    },
    usernameValue: {
      get: function () {
        return this.userObj.Username
      }
    },
    schoolValue: {
      get: function () {
        return this.userObj.School === null || this.userObj.School === 'null' ? '' : this.userObj.School
      }
    },
    selfSummaryValue: {
      get: function () {
        return this.userObj.SelfSummary === null || this.userObj.SelfSummary === 'null' ? '' : this.userObj.SelfSummary
      }
    },
    sessionTimeOutValue: {
      get: function () {
        if (parseInt(this.userObj.SessionTimeout) === 0) {
          return 'Not Set'
        } else {
          return this.userObj.SessionTimeout
        }
      }
    },
    sessionTimeOutUnitValue: {
      get: function () {
        var unit = ''
        if (this.sessionTimeOutValue === 'Not Set') {
          unit = ''
        } else {
          switch (this.userObj.SessionTimeoutUnit) {
            case constants.SessionTimeoutUnit.Minutes:
              unit = 'Minutes'
              break
            case constants.SessionTimeoutUnit.Hours:
              unit = 'Hours'
              break
            case constants.SessionTimeoutUnit.Days:
              unit = 'Days'
              break
            default:
              unit = ''
              break
          }
        }
        return unit
      }
    },
    createdTSValue: {
      get: function () {
        return this.userObj.CreatedTS
      }
    },
    disabledValue: {
      get: function () {
        var dataToPass = ''
        switch (this.userObj.Disabled) {
          case true:
            dataToPass = 'Yes'
            break
          case false:
            dataToPass = 'No'
            break
          default:
          case null:
            dataToPass = 'Not Set'
            break
        }
        return dataToPass
      }
    },
    disableProfileEditValue: {
      get: function () {
        var dataToPass = ''
        switch (this.userObj.DisableProfileEdit) {
          case true:
            dataToPass = 'Yes'
            break
          case false:
            dataToPass = 'No'
            break
          default:
          case null:
            dataToPass = 'Not Set'
            break
        }
        return dataToPass
      }
    },
    disableOfflineValue: {
      get: function () {
        var dataToPass = ''
        switch (this.userObj.DisableOffline) {
          case true:
            dataToPass = 'Yes'
            break
          case false:
            dataToPass = 'No'
            break
          default:
          case null:
            dataToPass = 'Not Set'
            break
        }
        return dataToPass
      }
    },
    genderValue: {
      get: function () {
        var gender = ''
        switch (this.userObj.Gender) {
          case constants.UserGender.Male:
            gender = 'Male'
            break
          case constants.UserGender.Female:
            gender = 'Female'
            break
          default:
            gender = 'Not Set'
            break
        }
        return gender
      }
    },
    accountTypeValue: {
      get: function () {
        var accountType = ''
        switch (this.userObj.AccountType) {
          case constants.UserAccountType.User:
            accountType = 'User'
            break
          case constants.UserAccountType.Group_Admin:
            accountType = 'Group Admin'
            break
          case constants.UserAccountType.Admin:
            accountType = 'Admin'
            break
          case constants.UserAccountType.Coach:
            accountType = 'Coach'
            break
          default:
            accountType = 'Not Set'
            break
        }
        return accountType
      }
    },
    userGroupValue: {
      get: function () {
        var userGroupType = ''
        switch (this.userObj.UserGroup) {
          case constants.GroupName.None:
            userGroupType = 'None'
            break
          case constants.GroupName.TCS:
            userGroupType = 'TCS'
            break
          case constants.GroupName.Morgan_Stanley:
            userGroupType = 'Morgan Stanley'
            break
          case constants.GroupName.Deloitte:
            userGroupType = 'Deloitte'
            break
          default:
            userGroupType = 'Not Set'
            break
        }
        return userGroupType
      }
    },
    bestScoreValue: {
      get: function () {
        return this.userObj.BestScore
      }
    },
    loginWithSSOValue: {
      get: function () {
        var dataToPass = ''
        switch (this.userObj.LoggedInWithSSO) {
          case true:
            dataToPass = 'Yes'
            break
          case false:
            dataToPass = 'No'
            break
          default:
          case null:
            dataToPass = 'Not Set'
            break
        }
        return dataToPass
      }
    },
    iOSVersionValue: {
      get: function () {
        return this.userObj.iOSVersion
      }
    },
    androidVersionValue: {
      get: function () {
        return this.userObj.AndroidVersion
      }
    },
    userTimeZoneValue: {
      get: function () {
        return this.userObj.TimeZoneId
      }
    },
    webVersionValue: {
      get: function () {
        return this.userObj.WebVersion
      }
    },
    msTeamEmailIdValue: {
      get: function () {
        return (this.userObj.MSTeamEmailId !== undefined && this.userObj.MSTeamEmailId !== 'undefined' && this.userObj.MSTeamEmailId !== null && this.userObj.MSTeamEmailId !== 'null' && this.userObj.MSTeamEmailId !== '' && this.userObj.MSTeamEmailId.length > 0) ? this.userObj.MSTeamEmailId : 'Not Set'
      }
    },
    enableMSTeamsValue: {
      get: function () {
        var dataToPass = ''
        switch (this.userObj.EnableMSTeams) {
          case true:
            dataToPass = 'Yes'
            break
          case false:
            dataToPass = 'No'
            break
          default:
          case null:
            dataToPass = 'Not Set'
            break
        }
        return dataToPass
      }
    },
    userImageUrlValue: {
      get: function () {
        return server.baseURL() + '/api/UserProfile/Picture?userId=' + this.userObj.UserId
      }
    },
    groupNameValue: {
      get: function () {
        const groupInfo = find(this.$store.state.groupList, {GroupId: this.userObj.GroupId})
        return groupInfo ? groupInfo.GroupName : 'Not Set'
      }
    },
    cohortNameValue: {
      get: function () {
        return this.userObj.CohortName !== undefined && this.userObj.CohortName !== 'undefined' && this.userObj.CohortName !== null && this.userObj.CohortName !== '' && this.userObj.CohortName.trim().length !== 0 ? this.userObj.CohortName : 'Not Available'
      }
    }
  }
}
</script>

<style scoped>
.img-circle {
    border-radius: 75px;
}
.background-color {
  background-color: #d4d4d4;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.img-circle {
    border-radius: 75px;
}
.background-color {
  background-color: #d4d4d4;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.user-img-width-height {
  width: 150px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewParticipantDetailsOverlay.vue